import React from "react";
import {autobind} from "core-decorators";
import {action, observable} from "mobx";
import {inject, observer} from "mobx-react";
import {Form, Input, Modal, Select} from "antd";
import {FormInstance} from "antd/es/form";

import "./InviteUserModal.scss";
import {inviteUser} from "@/lib/backend";
import Store from "@/stores";

export interface IInviteUserModalProps {
  onClose: () => Promise<void>;
  store?: Store;
  open: boolean;
}

@inject("store")
@autobind
@observer
export default class InviteUserModal extends React.Component<IInviteUserModalProps> {
  formRef = React.createRef<FormInstance>();
  @observable submitting: boolean = false;

  async onFormFinish(attrs: {email: string; role: string}) {
    this.setSubmitting(true);
    const {session} = this.props.store!;
    try {
      await inviteUser({
        ...attrs,
        ensembleId: session.selectedEnsemble!.id,
        ensembleName: session.selectedEnsemble!.name,
        inviterName: session.user!.name || session.user!.email,
      });
    } catch (error) {
      let content;
      if (error?.status && error?.status > 400) content = error?.data?.message || error?.data?.name;
      Modal.error({title: "Something went wrong", content});
    }
    this.setSubmitting(false);
    await this.props.onClose();
  }

  onOk() {
    this.formRef.current!.submit();
  }

  @action
  setSubmitting(submitting: boolean) {
    this.submitting = submitting;
  }

  public render() {
    const {onClose, open} = this.props;
    return (
      <Modal
        className="InviteUserModal"
        title="Invite user"
        open={open}
        onCancel={onClose}
        onOk={this.onOk}
        destroyOnClose={true}
        forceRender={true}
        width={400}
        okText="Invite"
        confirmLoading={this.submitting}
      >
        <Form ref={this.formRef} onFinish={this.onFormFinish} style={{width: 300}}>
          <Form.Item name="email" rules={[{required: true, message: "Please input an email"}]}>
            <Input type="email" placeholder="Email" />
          </Form.Item>
          <Form.Item name="role" rules={[{required: true, message: "Please input a role"}]} initialValue="singer">
            <Select>
              <Select.Option value="conductor">Conductor</Select.Option>
              <Select.Option value="singer">Singer</Select.Option>
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}
